import { mapAsyncForResult, Result } from "./deps/option-t.ts";
import {
  GetJsrPackageMetadataOptions,
  JSR_REGISTORY_ENDPOINT,
} from "./getJsrPackageMetadata.ts";
import {
  AbortError,
  HTTPError,
  NetworkError,
  robustFetch,
} from "./robustFetch.ts";

// cf. https://github.com/jsr-io/jsr/blob/c2a8b66449a7a8290b249dfa714468ce75d83a88/api/src/metadata.rs#L73-L116
export interface JsrPackageVersionMetadata {
  manifest: Record<string, ManifestEntry>;
  moduleGraph1?: Record<string, { yanked?: true }>;
  moduleGraph2?: Record<string, { yanked?: true }>;
  exports: Record<string, string>;
}

// cf. https://github.com/jsr-io/jsr/blob/c2a8b66449a7a8290b249dfa714468ce75d83a88/api/src/metadata.rs#L118-L122
export interface ManifestEntry {
  size: number;
  checksum: string;
}
export interface GetJsrPackageVersionMetadataOptions
  extends GetJsrPackageMetadataOptions {}

/** Get https://jsr.io/{scope}/{name}/{version}_meta.json
 *
 * For more information, see https://jsr.io/docs/api#package-version-metadata
 */
export const getJsrPackageVersionMetadata = async (
  name: string,
  version: string,
  options?: GetJsrPackageVersionMetadataOptions,
): Promise<
  Result<JsrPackageVersionMetadata, NetworkError | AbortError | HTTPError>
> => {
  const result = await (options?.fetch ?? robustFetch)(
    new Request(
      `${
        options?.endpoint ?? JSR_REGISTORY_ENDPOINT
      }/${name}/${version}_meta.json`,
    ),
    options?.cacheFirst,
  );
  return mapAsyncForResult(
    result,
    ([res]) => res.json() as Promise<JsrPackageVersionMetadata>,
  );
};

// denoCacheMetadata={"headers":{"x-fastly-request-id":"afe6f77531843ae03b19d4da92f623e841b18c17","x-frame-options":"deny","cache-control":"max-age=300","source-age":"90","via":"1.1 varnish","x-content-type-options":"nosniff","x-cache":"HIT","content-security-policy":"default-src 'none'; style-src 'unsafe-inline'; sandbox","content-type":"text/plain; charset=utf-8","x-served-by":"cache-iad-kcgs7200100-IAD","x-timer":"S1731060601.817971,VS0,VE1","x-cache-hits":"0","strict-transport-security":"max-age=31536000","expires":"Fri, 08 Nov 2024 10:15:00 GMT","date":"Fri, 08 Nov 2024 10:10:00 GMT","access-control-allow-origin":"*","cross-origin-resource-policy":"cross-origin","x-xss-protection":"1; mode=block","vary":"Authorization,Accept-Encoding,Origin","etag":"W/\"4835a7973d0b3422bd9c4aad1e5cbf6cee75fb9f9de62a636e11d0b748039101\"","accept-ranges":"bytes","x-github-request-id":"56F8:308556:2B34F8:2FE011:672DDE06"},"url":"https://raw.githubusercontent.com/takker99/ScrapJupyter/v1.7.4/getJsrPackageVersionMetadata.ts","time":1731060600}